import React from 'react';
import PropTypes from 'prop-types';
import styles from './PauseSlideContentV22.css';

function PauseSlideContentV22({ imageSrc, title, description }) {
    return (
        <section className={styles.form}>
            <img src={imageSrc} alt='' className={styles.image} />
            <h2 className={styles.heading}>{title}</h2>
            <div className={styles.description}>{description}</div>
        </section>
    );
}

PauseSlideContentV22.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired
};

export {
    PauseSlideContentV22
};
